module.exports = __webpack_public_path__ + "./img/ic_notification_empty.svg";